// ============================================================
// CONTENU DU SITE — FAFAPITI LODGE FAKARAVA
// Tout le contenu éditable du site est centralisé ici.
// Modifiez les valeurs ci-dessous : elles se répercutent partout.
// ============================================================

// ---- COORDONNÉES (page Contact + pied de page) ----
export const CONTACT = {
  email: "fafapitilodge@yahoo.com",
};

// ---- LES 5 BÂTIMENTS ----
// surface / capacity : laissez "" pour afficher "À compléter"
// virtualTourUrl : collez l'URL de la visite virtuelle (Matterport, 360…)
// hotspot : position du point sur la carte interactive (x/y en %)
// extPhotos / intPhotos : nombre d'emplacements photo dans les galeries
export const BUILDINGS = [
  {
    slug: "maison-principale",
    num: "01",
    name: { fr: "Maison principale", en: "Main House" },
    surface: "128 m²",
    noCapacity: true,
    description: {
      fr: "3 chambres, 1 salle de bain, salon avec bureau, 1 cellier, 1 cuisine aménagée et 1 grande terrasse.",
      en: "3 bedrooms, 1 bathroom, living room with office, 1 pantry, 1 fitted kitchen and 1 large terrace.",
    },
    virtualTourUrl: "https://my.matterport.com/show/?m=KRTPLQYtPvy",
    logo: "/images/logo.png",
    extImages: [
      "/images/maison-ext-05.webp",
      "/images/maison-ext-03.webp",
      "/images/maison-ext-04.webp",
      "/images/maison-ext-02.webp",
      "/images/maison-ext-01.webp",
    ],
    hotspot: { x: 72, y: 50 },
    extPhotos: 5,
    intPhotos: 8,
    intImages: [
      "/images/maison-int-08.webp",
      "/images/maison-int-06.webp",
      "/images/maison-int-07.webp",
      "/images/maison-int-01.webp",
      "/images/maison-int-02.webp",
      "/images/maison-int-04.webp",
      "/images/maison-int-03.webp",
      "/images/maison-int-05.webp",
    ],
  },
  {
    slug: "bungalow-honu",
    num: "02",
    name: { fr: "Bungalow Honu", en: "Honu Bungalow" },
    surface: "35 m²",
    capacity: { fr: "Bungalow double", en: "Double bungalow" },
    description: {
      fr: "Bungalow double avec chambre, salle de bain privée, dressing et terrasse. Chaque bungalow dispose de son propre chauffe-eau.",
      en: "Double bungalow with bedroom, private bathroom, dressing room and terrace. Each bungalow has its own water heater.",
    },
    virtualTourUrl: "https://my.matterport.com/show/?m=aEdLZbNqmW5",
    logo: "/images/logo-honu.png",
    extImages: [
      "/images/honu-ext-01.webp",
      "/images/honu-ext-02.webp",
      "/images/honu-ext-03.webp",
      { src: "/images/honu-ext-04.webp", pos: "center 25%" },
    ],
    hotspot: { x: 20, y: 48 },
    extPhotos: 4,
    intPhotos: 4,
    intImages: [
      "/images/honu-int-02.webp",
      "/images/honu-int-04.webp",
      "/images/honu-int-03.webp",
      "/images/honu-int-01.webp",
    ],
  },
  {
    slug: "bungalow-oua",
    num: "03",
    name: { fr: "Bungalow Oua", en: "Oua Bungalow" },
    surface: "35 m²",
    capacity: { fr: "Bungalow double", en: "Double bungalow" },
    description: {
      fr: "Chambre, salle de bain privée, dressing et terrasse. Chaque bungalow dispose de son propre chauffe-eau.",
      en: "Bedroom, private bathroom, walk-in wardrobe and terrace. Each bungalow has its own water heater.",
    },
    virtualTourUrl: "https://my.matterport.com/show/?m=p1yAoKhY5be",
    logo: "/images/logo-oua.png",
    extImages: [
      "/images/oua-ext-04.webp",
      "/images/oua-ext-03.webp",
      "/images/oua-ext-02.webp",
      "/images/oua-ext-01.webp",
    ],
    hotspot: { x: 50, y: 40 },
    extPhotos: 4,
    intPhotos: 4,
    intImages: [
      "/images/oua-int-03.webp",
      "/images/oua-int-02.webp",
      "/images/oua-int-01.webp",
      "/images/oua-int-04.webp",
    ],
  },
  {
    slug: "bungalow-mako",
    num: "04",
    name: { fr: "Bungalow Mako", en: "Mako Bungalow" },
    surface: "39 m²",
    capacity: {
      fr: "Bungalow quadruple (1 lit double + 2 lits simples)",
      en: "Quadruple bungalow (1 double bed + 2 single beds)",
    },
    description: {
      fr: "Chambre, salle de bain privée, dressing et terrasse. Chaque bungalow dispose de son propre chauffe-eau.",
      en: "Bedroom, private bathroom, walk-in wardrobe and terrace. Each bungalow has its own water heater.",
    },
    virtualTourUrl: "https://my.matterport.com/show/?m=z3rTbg5bKHe",
    logo: "/images/logo-mako.png",
    extImages: [
      "/images/mako-ext-02.webp",
      "/images/mako-ext-01.webp",
      "/images/mako-ext-03.webp",
      "/images/mako-ext-04.webp",
    ],
    hotspot: { x: 71, y: 33 },
    extPhotos: 4,
    intPhotos: 5,
    intImages: [
      "/images/mako-int-02.webp",
      "/images/mako-int-04.webp",
      "/images/mako-int-03.webp",
      "/images/mako-int-01.webp",
      "/images/mako-int-05.webp",
    ],
  },
  {
    slug: "garage",
    num: "05",
    name: { fr: "Garage", en: "Garage" },
    surface: "81 m²",
    noCapacity: true,
    description: {
      fr: "Salle de bain, local technique et buanderie.",
      en: "Bathroom, technical room and laundry room.",
    },
    virtualTourUrl: "https://my.matterport.com/show/?m=vuBEpfbuxJC",
    featureGallery: true,
    hotspot: { x: 35, y: 35 },
    extPhotos: 4,
    intPhotos: 5,
    intImages: [
      "/images/garage-int-01.webp",
      "/images/garage-int-02.webp",
      "/images/garage-int-03.webp",
      "/images/garage-int-04.webp",
      "/images/garage-int-05.webp",
    ],
    extImages: [
      "/images/garage-ext-01.webp",
      "/images/garage-ext-02.webp",
      "/images/garage-ext-03.webp",
      "/images/garage-ext-04.webp",
    ],
  },
  {
    slug: "fare-potee",
    num: "06",
    name: { fr: "Fare Pote", en: "Fare Pote" },
    noSurface: true,
    noCapacity: true,
    description: {
      fr: "Espace de vie commun et de détente. Ouvert sur le lagon, c'est l'endroit où l'on se retrouve pour partager les repas, l'apéritif et prolonger les soirées les pieds dans le sable.",
      en: "A shared living and relaxation space. Open onto the lagoon, it is where everyone gathers to share meals, enjoy a drink and linger into the evening with their feet in the sand.",
    },
    virtualTourUrl: "",
    noVirtualTour: true,
    hotspot: { x: 80, y: 67 },
    galleryImages: [
      "/images/fare-01.webp",
      "/images/fare-02.webp",
      "/images/fare-03.webp",
      "/images/fare-04.webp",
      "/images/fare-05.webp",
    ],
  },
];

// ---- TRADUCTIONS DE L'INTERFACE ----
export const COPY = {
  fr: {
    nav: {
      home: "Accueil",
      map: "Carte interactive",
      infos: "Infos complémentaires",
      mainHouse: "Maison principale",
      bungalows: "Bungalows",
      contact: "Contact",
      menu: "Menu",
      close: "Fermer",
    },
    hero: {
      overline: "Visite virtuelle · Atoll de Fakarava · Tuamotu · Polynésie française",
      line1: "Fafapiti",
      line2: "Lodge",
      line3: "Fakarava",
      sub: "Éco-lodge familial avec plage privée, face au lagon de Fakarava — Réserve de Biosphère UNESCO.",
      cta: "Découvrir le bien",
      scroll: "Défiler",
      heroPhoto: "PHOTO-HERO-01",
      coords: "16°10′ S — 145°34′ O",
    },
    marquee: [
      "Atoll de Fakarava",
      "Réserve de Biosphère UNESCO",
      "Plage privée",
      "Archipel des Tuamotu",
      "Polynésie française",
      "Face au lagon",
    ],
    chapters: {
      one: {
        kicker: "Chapitre 01",
        title: "Le bien et sa localisation",
        text1:
          "Fafapiti Lodge est une pension de famille posée sur le sable de Fakarava. Une maison principale et trois bungalows — Honu, Mako et Oua — sur un site entièrement autonome en eau et en électricité.",
        location:
          "Fakarava, deuxième atoll des Tuamotu par sa taille, est inscrite au programme sur l'Homme et la Biosphère (MAB) de l'UNESCO. Le terrain s'étend en bordure d'une plage privée, face au lagon.",
        landSurface: "4 000 m²",
        landBreakdown: "2 000 m² déjà construits + 2 000 m² constructibles",
        landLink: "voir Informations complémentaires",
        landSurfaceLabel: "Superficie du terrain",
        featuresLabel: "Spécificités",
        features: [
          "Autonome en eau et électricité",
          "Plage privée face au lagon",
          "Réserve de Biosphère UNESCO",
        ],
        cta: "Explorer la carte interactive",
        mapTitle: "Nous situer",
        mapLink: "Ouvrir dans Google Maps",
      },
      two: {
        kicker: "Chapitre 04",
        title: "Les bâtiments",
        hint: "Six constructions, un seul ensemble à découvrir.",
        visit: "Visiter",
      },
    },
    map: {
      overline: "Vue aérienne",
      chapterKicker: "Chapitre 02",
      title: "Carte interactive",      hint: "Cliquez sur un point pour découvrir chaque bâtiment.",
      placeholder: "VUE AÉRIENNE DU TERRAIN",
      sub: "image à venir",
      discover: "Découvrir",
      legend: "Index des bâtiments",
    },
    info: {
      kicker: "Chapitre 03",
      title: "Informations complémentaires",
      water: {
        title: "Les réseaux d'eau",
        text: "Deux réseaux d'eau sur la propriété.\n1 — Eau douce : récupération de l'eau de pluie, stockée dans 7 citernes interconnectées (capacité totale : 40 000 L). Elle est rendue potable grâce à un système de filtration installé dans la cuisine de la maison.\n2 — Eau saumâtre (non potable) : puisée dans 2 puits de la propriété, utilisée pour le jardin et les toilettes.",
        pointLabel: "Citernes d'eau",
        photos: ["/images/eau-01.webp"],
        filtration: {
          title: "Système de filtration — cuisine de la maison",
          from: "Eau des citernes",
          steps: ["Cartouche à sédiments", "Cartouche charbon actif", "Lampe UV"],
          to: "Eau potable",
        },
      },
      elec: {
        title: "L'électricité",
        text: "Installation photovoltaïque de 5,2 kWc avec stockage sur 24 batteries OPzS 1000.\nProduction solaire : 16,7 kWh/jour — stockage : 72 kWh.\n18 modules solaires REC 290 Wc.\n1 onduleur XTH 6000 VA — 48 V / 230 V (REV).\nGroupe électrogène silencieux de secours de 6 kW + raccord au réseau électrique communal (toujours en secours).",
        pointLabel: "Panneaux solaires",
        photos: ["/images/elec-01.webp", "/images/elec-02.webp"],
      },
      docs: [
        { title: "Permis de construire", text: "N°19-633-6/MLA.AU.TG du 18 novembre 2019" },
        { title: "Certificat de conformité", text: "N°16-633-7/MLA.DCA.TG du 27 avril 2021\nN°19-633-8/MLA/DCA.TG du 24 juin 2021" },
      ],
      cadastre: {
        title: "Plan cadastral",
        legend: [
          { color: "#0A1118", label: "CK56 — partie déjà construite" },
          { color: "#9CA3AF", label: "CK55 — partie constructible" },
          { color: "#FDE047", label: "CK57 — servitude de passage" },
        ],
        buildable: {
          title: "Partie constructible — CK55",
          text: "Parcelle prête pour l'implantation de nouvelles constructions.",
          photos: ["/images/ck55-01.webp", "/images/ck55-02.webp", "/images/ck55-03.webp"],
        },
      },
    },
    building: {
      overline: "Bâtiment",
      surface: "Surface",
      capacity: "Capacité",
      description: "Description",
      toComplete: "À compléter",
      exterior: "Extérieur",
      interior: "Intérieur",
      photos: "Photos",
      virtualTour: "Visite virtuelle",
      virtualTourEmpty: "Lien de visite virtuelle à ajouter",
      virtualTourHint: "Collez l'URL dans src/data/content.js → virtualTourUrl",
      openTour: "Ouvrir la visite virtuelle",
      backToMap: "Retour à la carte",
      prev: "Précédent",
      next: "Suivant",
      extLabel: "EXT",
      intLabel: "INT",
    },
    contact: {
      overline: "Visite virtuelle",
      title: "Contact",
      intro:
        "Pour toute demande d'information, de dossier ou de visite du bien, écrivez-nous directement par e-mail.",
      emailLabel: "E-mail",
      locationLabel: "Localisation",
      locationValue: "Atoll de Fakarava, Tuamotu, Polynésie française",
      note: "Visites sur rendez-vous uniquement.",
    },
    footer: {
      tagline: "Éco-lodge familial — Fakarava",
      sale: "Visite virtuelle",
      rights: "Tous droits réservés",
    },
    imageToCome: "Image à venir",
  },
  en: {
    nav: {
      home: "Home",
      map: "Interactive map",
      infos: "Additional info",
      mainHouse: "Main House",
      bungalows: "Bungalows",
      contact: "Contact",
      menu: "Menu",
      close: "Close",
    },
    hero: {
      overline: "Virtual tour · Fakarava Atoll · Tuamotu · French Polynesia",
      line1: "Fafapiti",
      line2: "Lodge",
      line3: "Fakarava",
      sub: "A family eco-lodge with a private beach, facing the Fakarava lagoon — a UNESCO Biosphere Reserve.",
      cta: "Discover the property",
      scroll: "Scroll",
      heroPhoto: "PHOTO-HERO-01",
      coords: "16°10′ S — 145°34′ W",
    },
    marquee: [
      "Fakarava Atoll",
      "UNESCO Biosphere Reserve",
      "Private beach",
      "Tuamotu Archipelago",
      "French Polynesia",
      "Facing the lagoon",
    ],
    chapters: {
      one: {
        kicker: "Chapter 01",
        title: "The property and its location",
        text1:
          "Fafapiti Lodge is a family guesthouse resting on the sands of Fakarava. A main house and three bungalows — Honu, Mako and Oua — on a site that is fully self-sufficient in water and electricity.",
        location:
          "Fakarava, the second largest atoll in the Tuamotu, is part of UNESCO's Man and the Biosphere (MAB) programme. The land stretches along a private beach, facing the lagoon.",
        landSurface: "4,000 m²",
        landBreakdown: "2,000 m² already built + 2,000 m² buildable",
        landLink: "see Additional information",
        landSurfaceLabel: "Land area",
        featuresLabel: "Highlights",
        features: [
          "Self-sufficient in water and electricity",
          "Private beach facing the lagoon",
          "UNESCO Biosphere Reserve",
        ],
        cta: "Explore the interactive map",
        mapTitle: "Find us",
        mapLink: "Open in Google Maps",
      },
      two: {
        kicker: "Chapter 04",
        title: "The buildings",
        hint: "Six structures, one single estate to explore.",
        visit: "Visit",
      },
    },
    map: {
      overline: "Aerial view",
      chapterKicker: "Chapter 02",
      title: "Interactive map",
      hint: "Click a dot to discover each building.",
      placeholder: "AERIAL VIEW OF THE LAND",
      sub: "image to come",
      discover: "Discover",
      legend: "Building index",
    },
    info: {
      kicker: "Chapter 03",
      title: "Additional information",
      water: {
        title: "The water networks",
        text: "Two separate water networks on the property.\n1 — Fresh water: rainwater collected and stored in 7 interconnected tanks (total capacity: 40,000 L). It is made drinkable by a filtration system installed in the main house kitchen.\n2 — Brackish water (non-drinking): drawn from 2 wells on the property, used for the garden and toilets.",
        pointLabel: "Water tanks",
        photos: ["/images/eau-01.webp"],
        filtration: {
          title: "Filtration system — main house kitchen",
          from: "Tank water",
          steps: ["Sediment cartridge", "Activated carbon cartridge", "UV lamp"],
          to: "Drinking water",
        },
      },
      elec: {
        title: "Electricity",
        text: "5.2 kWp photovoltaic system with 24 OPzS 1000 storage batteries.\nSolar output: 16.7 kWh/day — storage: 72 kWh.\n18 REC 290 Wp solar modules.\n1 XTH 6000 VA inverter — 48 V / 230 V (REV).\nSilent 6 kW backup generator + connection to the communal power grid (always as backup).",
        pointLabel: "Solar panels",
        photos: ["/images/elec-01.webp", "/images/elec-02.webp"],
      },
      docs: [
        { title: "Building permit", text: "N°19-633-6/MLA.AU.TG of November 18, 2019" },
        { title: "Certificate of conformity", text: "N°16-633-7/MLA.DCA.TG of April 27, 2021\nN°19-633-8/MLA/DCA.TG of June 24, 2021" },
      ],
      cadastre: {
        title: "Cadastral plan",
        legend: [
          { color: "#0A1118", label: "CK56 — already built area" },
          { color: "#9CA3AF", label: "CK55 — buildable area" },
          { color: "#FDE047", label: "CK57 — right of way" },
        ],
        buildable: {
          title: "Buildable area — CK55",
          text: "Plot ready for new constructions.",
          photos: ["/images/ck55-01.webp", "/images/ck55-02.webp", "/images/ck55-03.webp"],
        },
      },
    },
    building: {
      overline: "Building",
      surface: "Surface",
      capacity: "Capacity",
      description: "Description",
      toComplete: "To be completed",
      exterior: "Exterior",
      interior: "Interior",
      photos: "Photos",
      virtualTour: "Virtual tour",
      virtualTourEmpty: "Virtual tour link to be added",
      virtualTourHint: "Paste the URL in src/data/content.js → virtualTourUrl",
      openTour: "Open the virtual tour",
      backToMap: "Back to the map",
      prev: "Previous",
      next: "Next",
      extLabel: "EXT",
      intLabel: "INT",
    },
    contact: {
      overline: "Virtual tour",
      title: "Contact",
      intro:
        "For any enquiry, brochure or viewing of the property, write to us directly by e-mail.",
      emailLabel: "E-mail",
      locationLabel: "Location",
      locationValue: "Fakarava Atoll, Tuamotu, French Polynesia",
      note: "Viewings by appointment only.",
    },
    footer: {
      tagline: "Family eco-lodge — Fakarava",
      sale: "Virtual tour",
      rights: "All rights reserved",
    },
    imageToCome: "Image to come",
  },
};
